// src/components/strumenti/VolumeTubazione.js — W442. Acqua contenuta in una tubazione
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { volumeTubazione } from "../../utils/calcoliStrumenti";

export default function VolumeTubazione() {
  const { v, set, n, azzera } = useCampi({ d:"", l:"" });
  const r = volumeTubazione(n("d"), n("l"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Diametro interno (mm)" valore={v.d} onChange={set("d")} placeholder="Es. 20" aiuto="Interno, non esterno (es. multistrato 26×3 → 20 mm)."/>
        <Campo etichetta="Lunghezza (m)" valore={v.l} onChange={set("l")} placeholder="Es. 100"/>
      </Griglia>
      <Risultato settore="idraulico" titolo="Acqua contenuta" valore={fmt(r?.litri, 2)} unita="litri"
        righe={r ? [["Per metro di tubo", fmt(r.litriAlMetro, 4) + " l/m"], ["In m³", fmt(r.litri / 1000, 4)]] : []}/>
      <Formula>Litri = π × d² ÷ 4 × L × 1000 (d in metri). Utile per il riempimento dell'impianto, la quantità di antigelo o il tempo di attesa dell'acqua calda.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
